import Swal from 'sweetalert2';

/**
 * GDR Jewellers SweetAlert2 Utility
 * Provides cohesive, branded popup and toast notifications.
 */

export const showSuccessAlert = (title, text = '') => {
  return Swal.fire({
    icon: 'success',
    title: title,
    text: text,
    confirmButtonColor: '#E53A10',
    confirmButtonText: 'OK'
  });
};

export const showErrorAlert = (title, text = '') => {
  return Swal.fire({
    icon: 'error',
    title: title,
    text: text,
    confirmButtonColor: '#E53A10',
    confirmButtonText: 'OK'
  });
};

export const showConfirmDialog = async (title, text, confirmButtonText = 'Yes, Proceed') => {
  const result = await Swal.fire({
    title: title,
    text: text,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#E53A10',
    cancelButtonColor: '#64748b',
    confirmButtonText: confirmButtonText,
    cancelButtonText: 'Cancel'
  });
  return result.isConfirmed;
};

export const showToast = (title, icon = 'success') => {
  return Swal.fire({
    toast: true,
    position: 'top-end',
    icon: icon,
    title: title,
    showConfirmButton: false,
    timer: 2500,
    timerProgressBar: true
  });
};

export default Swal;
